// extracted by mini-css-extract-plugin
export default {"Cropper":"Crop_Cropper__74Ad6","CropContainer":"Crop_CropContainer__BK1xR","CropControls":"Crop_CropControls__MMhOS"};